export enum InputAcceptType {
  csv = '.csv,text/csv',
  json = '.json,application/json'
}
